import { ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE } from '../EntityProfileTabUpdates.constants'

export function getEntityProfileTabUpdateDisplayName({
  deletedOwnerNameKey,
  owner,
  systemOwnerNameKey,
  t,
  type,
}) {
  switch (type) {
    case ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE.system:
      return t(systemOwnerNameKey)
    case ENTITY_PROFILE_TAB_UPDATES_OWNER_TYPE.deleted:
      return t(deletedOwnerNameKey)
    default:
      return owner?.fullname || null
  }
}
